import React from "react";

import { StyledSVG } from "../StyledIcon";

export const LearnIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <path
        d="M20 13C20 10.7909 21.7909 9 24 9H36.9412V31.2353H24C21.7909 31.2353 20 33.0262 20 35.2353V36V13Z"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 11C20 8.79086 18.2091 7 16 7H3.05882V29.2353H16C18.2091 29.2353 20 31.0262 20 33.2353V34V11Z"
        stroke={iconColor}
        vectorEffect="non-scaling-stroke"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
